const html = document.documentElement; //eslint-disable-line

function setContrastEnabled(enabled = false): void {
  html.classList.toggle('t-high-contrast', enabled);
}

function setFontSize(size = 100): void {
  html.style.fontSize = `${size}%`;
}

function toggleContrast(): void {
  html.classList.toggle('t-high-contrast');
}

function increaseFontSize(fontSizeStep = 10, maxFontSize = 150): void {
  const newFontSize = Math.min((getFontSize() + fontSizeStep), maxFontSize);
  setFontSize(newFontSize);
}

function decreaseFontSize(fontSizeStep = 10, minFontSize = 70): void {
  const newFontSize = Math.max((getFontSize() - fontSizeStep), minFontSize);
  setFontSize(newFontSize);
}

function getFontSize(): number {
  return Number.parseInt(html.style.fontSize || '100');
}

function isContrastEnabled(): boolean {
  return html.classList.contains('t-high-contrast');
}

function scrollToBottom(): void {
  window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
}

function scrollToTop(): void {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

export {
  decreaseFontSize,
  getFontSize,
  increaseFontSize,
  isContrastEnabled,
  scrollToBottom,
  scrollToTop,
  setContrastEnabled,
  setFontSize,
  toggleContrast,
};

export default {
  decreaseFontSize,
  getFontSize,
  increaseFontSize,
  isContrastEnabled,
  scrollToBottom,
  scrollToTop,
  setContrastEnabled,
  setFontSize,
  toggleContrast,
};
